import React, { useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "react-perfect-scrollbar/dist/css/styles.css";
import Track from "../track/Track";
import ProviderCbxFilter from "../utilities/ProviderCbxFilter";

const TrackList = ({
  selectOption,
  setSelectOption,
  tracksDate,
  setTracksDate,
  stateTracks,
  openTracks,
  setOpenTracks,
  racesTracks,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  gameProviders,
  selectedProvider,
  setSelectedProvider,
  setUpcomingRaceSelected,
  setOffRaceSelected,
  setResultsList,
  setReadOnlyResults,
  setSelectAllTickets,
  setSelectedTicketsVoidScore,
  setChangeProviderFilter,
}) => {
  const [alphabeticalTrackList, setAlphabeticalTrackList] = useState(false);
  const divRef = useRef(null);
  const [showThoroughbredTracks, setShowThoroughbredTracks] = useState(true);
  const [showHarnessTracks, setShowHarnessTracks] = useState(true);
  const [showGreyhoundsTracks, setShowGreyhoundsTracks] = useState(true);
  const [showFilters, setShowFilters] = useState(true);
  const [showSpecialEventsTracks, setShowSpecialEventsTracks] = useState(true);

  //Onchange Special Event Checkboxes
  const handleCheckboxChange = (e) => {
    setAlphabeticalTrackList(e.target.checked);
    setOpenTracks([]);
    const div = divRef.current;
    if (div) {
      div.scrollTop = 0;
    }
  };

  return (
    <nav
      className="pcoded-navbar"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div
        className="navbar-wrapper"
        style={{ flex: "1", display: "flex", flexDirection: "column" }}
      >
        <div className={`${!showFilters ? "mb-3 " : ""}text-center mr-4 ml-4`}>
          <label
            className="font-weight-bold m-t-10"
            style={{ fontSize: "20px", marginBottom: "0px", cursor: "pointer" }}
            onClick={() => setShowFilters(!showFilters)}
          >
            Racing Manager
          </label>
        </div>
        {showFilters && (
          <div>
            <div className="text-center mr-4 ml-4 mb-1 mt-2">
              <DatePicker
                selected={tracksDate}
                onChange={(date) => {
                  setTracksDate(date);
                }}
                className="form-control text-center"
              />
            </div>
            <div className="text-center mr-4 ml-4 mb-1">
              <ProviderCbxFilter
                gameProviders={gameProviders}
                setSelectedProvider={setSelectedProvider}
                selectedProvider={selectedProvider}
                widthCbx={"270px"}
                label={false}
                setChangeProviderFilter={setChangeProviderFilter}
              />
            </div>
            <div
              className="form-group form-check"
              style={{
                paddingLeft: "25px",
                margin: "0px",
                height: "22px",
              }}
            >
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="switchAlphabeticalEvent"
                  name="alphabeticalTrackList"
                  checked={alphabeticalTrackList}
                  onChange={(e) => handleCheckboxChange(e)}
                />
                <label
                  className="custom-control-label lead"
                  htmlFor="switchAlphabeticalEvent"
                >
                  Alphabetical Track List
                </label>
              </div>
            </div>
          </div>
        )}

        <div
          className="navbar-content scroll-div"
          style={{ overflow: "auto", flex: "1" }}
          ref={divRef}
        >
          <ul className="nav pcoded-inner-navbar">
            {!alphabeticalTrackList ? (
              <>
                {stateTracks && stateTracks.specialEventsList.length !== 0 && (
                  <>
                    <li className="nav-item pcoded-menu-caption">
                      <label
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          cursor: "pointer",
                        }}
                        className=""
                        onClick={() =>
                          setShowSpecialEventsTracks(!showSpecialEventsTracks)
                        }
                      >
                        <span className="pcoded-micon">
                          <img
                            className="thoroughbredIcon "
                            src="../images/SpecialEventsWhite.png"
                            alt=""
                          />
                        </span>{" "}
                        Special Events
                      </label>
                    </li>
                    {showThoroughbredTracks &&
                      stateTracks.specialEventsList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={track.TrackID}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            races={racesTracks.find(
                              (item) => item[0].TrackID === track.TrackID,
                            )}
                            status={status}
                            setRefreshInfo={setRefreshInfo}
                            refreshInfo={refreshInfo}
                            setRefreshEntries={setRefreshEntries}
                            refreshEntries={refreshEntries}
                            setUpcomingRaceSelected={setUpcomingRaceSelected}
                            setOffRaceSelected={setOffRaceSelected}
                            setResultsList={setResultsList}
                            openTracks={openTracks}
                            setReadOnlyResults={setReadOnlyResults}
                            setSelectAllTickets={setSelectAllTickets}
                            setSelectedTicketsVoidScore={
                              setSelectedTicketsVoidScore
                            }
                          />
                        );
                      })}
                  </>
                )}
                {stateTracks && stateTracks.thoroughbredList.length !== 0 && (
                  <>
                    <li className="nav-item pcoded-menu-caption">
                      <label
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          cursor: "pointer",
                        }}
                        className=""
                        onClick={() =>
                          setShowThoroughbredTracks(!showThoroughbredTracks)
                        }
                      >
                        <span className="pcoded-micon">
                          <img
                            className="thoroughbredIcon "
                            src="../images/ThoroughbredWhite.png"
                            alt=""
                          />
                        </span>{" "}
                        Thoroughbred
                      </label>
                    </li>
                    {showThoroughbredTracks &&
                      stateTracks.thoroughbredList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={track.TrackID}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            races={racesTracks.find(
                              (item) => item[0].TrackID === track.TrackID,
                            )}
                            status={status}
                            setRefreshInfo={setRefreshInfo}
                            refreshInfo={refreshInfo}
                            setRefreshEntries={setRefreshEntries}
                            refreshEntries={refreshEntries}
                            setUpcomingRaceSelected={setUpcomingRaceSelected}
                            setOffRaceSelected={setOffRaceSelected}
                            setResultsList={setResultsList}
                            openTracks={openTracks}
                            setReadOnlyResults={setReadOnlyResults}
                            setSelectAllTickets={setSelectAllTickets}
                            setSelectedTicketsVoidScore={
                              setSelectedTicketsVoidScore
                            }
                          />
                        );
                      })}
                  </>
                )}

                {stateTracks && stateTracks.harnessList.length !== 0 && (
                  <>
                    <li className="nav-item pcoded-menu-caption">
                      <label
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowHarnessTracks(!showHarnessTracks)}
                      >
                        <span className="pcoded-micon">
                          <img
                            className="thoroughbredIcon"
                            src="../images/HarnessWhite.png"
                            alt=""
                          />
                        </span>{" "}
                        Harness
                      </label>
                    </li>
                    {showHarnessTracks &&
                      stateTracks.harnessList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={track.TrackID}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            races={racesTracks.find(
                              (item) => item[0].TrackID === track.TrackID,
                            )}
                            status={status}
                            setRefreshInfo={setRefreshInfo}
                            refreshInfo={refreshInfo}
                            setRefreshEntries={setRefreshEntries}
                            refreshEntries={refreshEntries}
                            setUpcomingRaceSelected={setUpcomingRaceSelected}
                            setOffRaceSelected={setOffRaceSelected}
                            setResultsList={setResultsList}
                            openTracks={openTracks}
                            setReadOnlyResults={setReadOnlyResults}
                            setSelectAllTickets={setSelectAllTickets}
                            setSelectedTicketsVoidScore={
                              setSelectedTicketsVoidScore
                            }
                          />
                        );
                      })}
                  </>
                )}

                {stateTracks && stateTracks.greyList.length !== 0 && (
                  <>
                    <li className="nav-item pcoded-menu-caption">
                      <label
                        style={{
                          fontSize: "14px",
                          marginBottom: "0px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setShowGreyhoundsTracks(!showGreyhoundsTracks)
                        }
                      >
                        <span className="pcoded-micon">
                          <img
                            className="thoroughbredIcon"
                            src="../images/GreyhoundsWhite.png"
                            alt=""
                          />
                        </span>{" "}
                        Greyhounds
                      </label>
                    </li>
                    {showGreyhoundsTracks &&
                      stateTracks.greyList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={track.TrackID}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            races={racesTracks.find(
                              (item) => item[0].TrackID === track.TrackID,
                            )}
                            status={status}
                            setRefreshInfo={setRefreshInfo}
                            refreshInfo={refreshInfo}
                            setRefreshEntries={setRefreshEntries}
                            refreshEntries={refreshEntries}
                            setUpcomingRaceSelected={setUpcomingRaceSelected}
                            setOffRaceSelected={setOffRaceSelected}
                            setResultsList={setResultsList}
                            openTracks={openTracks}
                            setReadOnlyResults={setReadOnlyResults}
                            setSelectAllTickets={setSelectAllTickets}
                            setSelectedTicketsVoidScore={
                              setSelectedTicketsVoidScore
                            }
                          />
                        );
                      })}
                  </>
                )}
              </>
            ) : (
              <>
                {stateTracks && stateTracks.trackList.length !== 0 && (
                  <>
                    {stateTracks.trackList.map((track, index) => {
                      let status = "open";
                      if (openTracks.includes(track.TrackID)) {
                        status = "close";
                      }

                      return (
                        <Track
                          key={track.TrackID}
                          track={track}
                          setSelectOption={setSelectOption}
                          selectOption={selectOption}
                          stateTracks={stateTracks} //Todos los tracks
                          races={racesTracks.find(
                            (item) => item[0].TrackID === track.TrackID,
                          )}
                          status={status}
                          setRefreshInfo={setRefreshInfo}
                          refreshInfo={refreshInfo}
                          setRefreshEntries={setRefreshEntries}
                          refreshEntries={refreshEntries}
                          setUpcomingRaceSelected={setUpcomingRaceSelected}
                          setOffRaceSelected={setOffRaceSelected}
                          setResultsList={setResultsList}
                          openTracks={openTracks}
                          setReadOnlyResults={setReadOnlyResults}
                          setSelectAllTickets={setSelectAllTickets}
                          setSelectedTicketsVoidScore={
                            setSelectedTicketsVoidScore
                          }
                        />
                      );
                    })}
                  </>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default TrackList;
